import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

// Components
import EditNoteIcon from 'dibs-vg/dist/react/note-edit';
import BlankNoteIcon from 'dibs-vg/dist/react/note-blank';

// Helpers
import classnames from 'classnames';

// Styles
import styles from './styles/Note.scss';

export default function Note({
    disabled,
    hasExistingNote,
    isListView,
    isPublic,
    onClick,
    noteContent,
}) {
    const [showBlankNoteIcon, setShowBlankNoteIcon] = useState(true);

    const NoteIcon = showBlankNoteIcon ? BlankNoteIcon : EditNoteIcon;
    const noteClasses = classnames(styles.note, {
        [styles.gridView]: !isListView,
    });

    if (hasExistingNote) {
        return (
            <div
                data-tn="note-preview"
                className={classnames(noteClasses, styles.edit, {
                    [styles.disabled]: disabled,
                })}
                onMouseLeave={() => setShowBlankNoteIcon(true)}
                onMouseOver={() => setShowBlankNoteIcon(false)}
                onClick={onClick}
            >
                <NoteIcon className={styles.icon} />
                <div
                    className={classnames(styles.noteContent, {
                        [styles.gridView]: !isListView,
                    })}
                >
                    {noteContent}
                </div>
            </div>
        );
    } else if (!isPublic) {
        return (
            <div className={noteClasses}>
                <div
                    className={classnames(styles.add, { [styles.disabled]: disabled })}
                    data-tn="note-link"
                    onClick={onClick}
                >
                    <FormattedMessage id="portfolio.listView.addNote" defaultMessage="Add note" />
                </div>
            </div>
        );
    }
    return null;
}

Note.defaultProps = {
    noteContent: '',
    isPublic: false,
    isListView: false,
};

Note.propTypes = {
    disabled: PropTypes.bool,
    hasExistingNote: PropTypes.bool,
    noteContent: PropTypes.string,
    onClick: PropTypes.func,
    selecting: PropTypes.bool,
    isPublic: PropTypes.bool,
    isListView: PropTypes.bool,
};
